<template>
  <v-dialog v-model="showMsg"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">
        <v-card-title>
          <v-chip
              label small
              class="ma-2"
              color="secondary"
          >
            مشاهده پیام
          </v-chip>

          <v-spacer/>
          <v-btn style="background-color:#be1e0b" dark icon @click.stop="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" lazy-validation v-model="valid">
            <v-row>

              <v-col cols="12"
                     sm="12"
                     md="3">
                <label> <span style="color: black">نام مجتمع:</span> {{ model.building }}</label>
              </v-col>
              <v-col cols="12"
                     sm="12"
                     md="3">

                <label> <span style="color: black">نام واحد:</span>{{ model.unitName }}</label>
              </v-col>
              <v-col cols="12"
                     sm="12"
                     md="3">
                <label> <span style="color: black">نام شخص:</span>{{ model.fullName }}</label>
              </v-col>
              <v-col cols="12"
                     sm="12"
                     md="3">
                <label>
                  <span style="color: black">نام کاربری:</span> {{ model.userName }}
                </label>
              </v-col>

              <v-col cols="12"
                     sm="12"
                     md="3">
                <label> <span style="color: black">تاریخ ثبت سند:</span>{{ model.dateText }}</label>
              </v-col>
              <v-col cols="12"
                     sm="12"
                     md="3">
                <label> <span style="color: black">تاریخ ایجاد سند:</span>{{ model.createdAtTxt }}</label>
              </v-col>
              <v-col cols="12"
                     sm="12"
                     md="3">
                <label> <span style="color: black">تاریخ ارسال پیام:</span>{{ model.sendDateText }}</label>
              </v-col>
              <v-col cols="12"
                     sm="12"
                     md="12">
                <v-card-text style="white-space: pre-wrap;text-align: right">
                  <span style="color: black">متن پیام:</span>
                  <br/>
                  {{ model.message }}
                </v-card-text>
              </v-col>
            </v-row>


          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>

export default {

  props: {
    showMsg: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      valid: true,
    }
  },

  methods: {
    closed() {
      this.$emit('update:showMsg', false)
    },
  },


}
</script>


